import CopyIcon from "@redotech/redo-icons/copy-01.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useContext, useMemo } from "react";
import { REDO_CHAT_WIDGET_URL } from "../../../config";
import { TeamContext } from "../../team";

export const CustomerWidgetScriptTag = memo(function CustomerWidgetScriptTag() {
  const team = useContext(TeamContext);

  const handleCopy = async (code: string) => {
    await navigator.clipboard.writeText(code);
  };

  const code = useMemo(() => {
    if (!team) {
      return "";
    }

    return `
<script async src="${REDO_CHAT_WIDGET_URL}/widget.js?widgetId=${team.widget_slug}"></script>
    `.trim();
  }, [team]);

  return (
    <Card radius="sm" title="Customer Widget script tag">
      <Flex dir="column" gap="md">
        <Text fontSize="sm">
          Use the following code <strong>only</strong> to test/demo the Customer
          Widget. Do not use this during implementation, instead enable the
          Customer Widget from the merchant dashboard settings.
        </Text>
        <Flex align="center" dir="row" gap="md">
          <Flex
            bgColor="tertiary"
            grow={1}
            p="xl"
            radius="sm"
            style={{ wordBreak: "break-all" }}
          >
            <code>{code}</code>
          </Flex>
          <RedoButton
            hierarchy="tertiary"
            IconLeading={CopyIcon}
            onClick={() => handleCopy(code)}
            size="sm"
          />
        </Flex>
      </Flex>
    </Card>
  );
});
